import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css, StyledComponentProps } from "styled-components";

export interface OrderInvoiceDetailsStyles {
    container?: InjectableCss;
    gridItem?: GridItemProps;
    leftWrapper?: InjectableCss;
    mobileContainer?: InjectableCss;
    mobileItem?: InjectableCss;
    rightWrapper?: InjectableCss;
    invoiceGridItem?: GridItemProps;
    topLeftcontainer?: InjectableCss;
    mobileTopcontainer?: InjectableCss;
    orderTotalgridItem?: GridItemProps;
    mobileGridItem?: GridItemProps;
}

export const invoiceStyles: OrderInvoiceDetailsStyles = {
    container: {
        css: css`
            display: grid;
            grid-template-columns: 7fr 3fr;
            gap: 6px;
            margin-top: 16px;
        `,
    },
    leftWrapper: {
        css: css`
            display: grid;
            grid-template-columns: 1fr;
            column-gap: 6px;
            row-gap: 6px;
        `,
    },
    rightWrapper: {
        css: css`
            display: flex;
            > div[class^="GridItemStyle"] {
                min-width: fit-content;
            }
        `,
    },

    topLeftcontainer: {
        css: css`
            display: flex;
            gap: 6px;
        `,
    },
    gridItem: {
        css: css`
            display: flex;
            justify-content: center;
            background-color: ${getColor("common.accent")};
            align-items: center !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css``,
                    css``,
                    css`
                        padding: 6px 12px;
                    `,
                ])}
            @media print {
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
            }
        `,
    },
    mobileContainer: {
        css: css`
            display: grid;
            grid-template-rows: auto auto auto;
            row-gap: 6px;
        `,
    },
    mobileTopcontainer: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, auto);
            gap: 6px;
        `,
    },
    mobileItem: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${getColor("common.accent")};
            width: 100%;
            height: 100%;
            padding: 3px 0px;
        `,
    },
    orderTotalgridItem: {
        css: css`
            justify-content: center;
            background-color: ${getColor("common.accent")};
            align-items: start !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css``,
                    css``,
                    css`
                        padding: 6px 12px;
                    `,
                ])}
        `,
    },
};

const styles = invoiceStyles;

const OrderInvoiceDetails: React.FC<WidgetProps> = ({ id }) => {
    return (
        <>
            <Hidden below="md">
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.leftWrapper}>
                        <StyledWrapper {...styles.topLeftcontainer}>
                            <GridItem {...styles.gridItem} width={3}>
                                <Zone contentId={id} zoneName="Zone0" />
                            </GridItem>
                            <GridItem {...styles.gridItem} width={3}>
                                <Zone contentId={id} zoneName="Zone1" />
                            </GridItem>
                            <GridItem {...styles.gridItem} width={3}>
                                <Zone contentId={id} zoneName="Zone2" />
                            </GridItem>
                            <GridItem {...styles.gridItem} width={3}>
                                <Zone contentId={id} zoneName="Zone3" />
                            </GridItem>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.rightWrapper} className="wrapper-right">
                        <GridItem {...styles.orderTotalgridItem} width={6}>
                            <Zone contentId={id} zoneName="Zone5" />
                        </GridItem>
                    </StyledWrapper>
                    <StyledWrapper {...styles.leftWrapper}>
                        <StyledWrapper {...styles.topLeftcontainer}>
                            <Zone contentId={id} zoneName="Zone4" />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>
            <Hidden above="sm">
                <StyledWrapper>
                    <StyledWrapper {...styles.mobileContainer}>
                        <StyledWrapper {...styles.mobileTopcontainer}>
                            <StyledWrapper {...styles.mobileItem}>
                                <Zone contentId={id} zoneName="Zone-M0" />
                            </StyledWrapper>
                            <StyledWrapper {...styles.mobileItem}>
                                <Zone contentId={id} zoneName="Zone-M1" />
                            </StyledWrapper>
                            <StyledWrapper {...styles.mobileItem}>
                                <Zone contentId={id} zoneName="Zone-M2" />
                            </StyledWrapper>
                            <StyledWrapper {...styles.mobileItem}>
                                <Zone contentId={id} zoneName="Zone-M3" />
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="Zone-M4" />
                        </StyledWrapper>
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="Zone-M5" />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderInvoiceDetails,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage", "CustomOrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;
